module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-bloc', [_c('h3', {
    staticClass: "mg-sm text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home.index'
      }
    }
  }, [_vm._v("Coneron")])], 1)]), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("Liity palveluun")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register(_vm.user)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Yrityksen nimi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.organizationName),
      expression: "user.organizationName"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "organization",
      "name": "organizationName",
      "data-vv-as": "Yrityksen nimi",
      "type": "text",
      "placeholder": "Yrityksen nimi"
    },
    domProps: {
      "value": (_vm.user.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.organizationName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('organizationName')),
      expression: "errors.has('organizationName')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('organizationName')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Etunimi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "given-name",
      "name": "firstName",
      "data-vv-as": "Etunimi",
      "type": "text",
      "placeholder": "Etunimi"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstName')),
      expression: "errors.has('firstName')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('firstName')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Sukunimi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "family-name",
      "name": "lastName",
      "data-vv-as": "Sukunimi",
      "type": "text",
      "placeholder": "Sukunimi"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastName')),
      expression: "errors.has('lastName')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('lastName')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Valitse yrityksen tyyppi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.organizationTypeId),
      expression: "user.organizationTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.organizationTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": 1
    }
  }, [_vm._v("Rakennusliike")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Rakennusliikkeiden alihankkija")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-form-label",
    attrs: {
      "for": "inputEmail4"
    }
  }, [_vm._v("Sähköposti")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "email",
      "data-vv-as": "Sähköposti",
      "placeholder": "Sähköposti"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Salasana")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8'),
      expression: "'required|min:8'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "new-password",
      "name": "password",
      "data-vv-as": "Salasana",
      "type": "password",
      "placeholder": "Salasana"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-deep-magenta"
  }, [_vm._v("\n                Liity palveluun\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        Oletko jo liittynyt palveluun?\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login.index'
      }
    }
  }, [_vm._v("Kirjaudu sisään")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-52fd89de"}!./src/app/pages/register/index/index.html
// module id = 480
// module chunks = 1